import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserKind } from '../../stores/auth.store';
import { StaffRole } from '@bisa/shared';
import { PageSpinner } from '../ui/Spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireKind?: UserKind;
  requireRole?: StaffRole[];
}

export function ProtectedRoute({ children, requireKind, requireRole }: ProtectedRouteProps) {
  const { session, kind, staff, loading } = useAuthStore();

  if (loading) return <PageSpinner />;
  if (!session) return <Navigate to="/login" replace />;

  if (requireKind && kind !== requireKind) return <Navigate to="/" replace />;
  if (requireRole && staff && !requireRole.includes(staff.role)) return <Navigate to="/" replace />;

  return <>{children}</>;
}
